import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BrandMark } from '../components/BrandMark';
import { Button } from '../components/ui/Button';
import { AdminThumbnail } from '../components/marco2/AdminThumbnail';
import { MobileThumbnail } from '../components/marco2/MobileThumbnail';
import { ReviewScreenCard } from '../components/marco2/ReviewScreenCard';
import { adminReviewScreens, marco2Deliverables, mobileReviewScreens, notInThisDelivery } from '../data/marco2';
import { withClientReview } from '../utils/clientReview';
const statusBadges = [{
  label: 'PROTÓTIPO',
  text: 'Experiência implementada para validação.'
}, {
  label: 'MARCO 3',
  text: 'Backend e versão Alpha ainda serão implementados.'
}, {
  label: 'FUTURO',
  text: 'Integrações e recursos previstos no roadmap.'
}];
function SectionHeading({
  title,
  subtitle,
  id
}: {
  title: string;
  subtitle: string;
  id: string;
}) {
  return <div className="mb-3 flex flex-col gap-1 border-b border-sand-line pb-2 md:flex-row md:items-end md:justify-between" data-id="element-3311" data-mp="1lef5uda40m5">
      <h2 id={id} className="text-title text-deep" data-id="element-3312" data-mp="2kwwdah1r9sx3">
        {title}
      </h2>
      <p className="text-label text-muted" data-id="element-3313" data-mp="2pvfygf8iz0oe">{subtitle}</p>
    </div>;
}

/** Client review index for Marco 2 — UX/UI e Fundação. Links to existing screens only. */
export function Marco2() {
  const navigate = useNavigate();
  return <div className="min-h-screen w-full bg-sand text-deep" data-id="element-3314" data-mp="2zmalhltli4aw">
      <header className="bg-deep text-sand" data-id="element-3315" data-mp="34i96r0jmn673">
        <div className="mx-auto max-w-[1200px] px-3 pb-6 pt-4 md:px-5" data-id="element-3316" data-mp="34ln7k4cn77cf">
          {/* Interim: the approved gold symbol alone, since the dark-background lockup
              (cream wordmark) is not in the project yet. Swap to that asset when provided. */}
          <BrandMark size={44} data-id="element-3317" data-mp="3ihqynos7yzko" />
          <div className="mt-6 grid gap-4 lg:grid-cols-[1.3fr_1fr] lg:items-end" data-id="element-3318" data-mp="3igzct5ofcg7l">
            <div data-id="element-3319" data-mp="1j7ivtgnu3b5a">
              <h1 className="text-[34px] font-bold leading-[1.08] md:text-[48px]" data-id="element-3320" data-mp="1j828oiymn9cg">BEELYV — Marco 2</h1>
              <p className="mt-1 text-[18px] font-medium text-gold md:text-[20px]" data-id="element-3321" data-mp="1o6vq2mh1bkhw">UX/UI e Fundação</p>
              <p className="mt-3 max-w-[620px] text-[15px] leading-relaxed text-ondark" data-id="element-3322" data-mp="1g665wcwpusm0">
                Este ambiente apresenta os principais fluxos e telas desenvolvidos para o App Mobile e o
                Admin Web do BEELYV, além da fundação definida para a próxima etapa de implementação. Os
                dados exibidos no protótipo são demonstrativos.
              </p>
            </div>
            <ul className="flex flex-col gap-1" aria-label="Legenda de status" data-id="element-3323" data-mp="1z0upfalb0085">
              {statusBadges.map(badge => <li key={badge.label} className="flex items-center gap-2 rounded-card border border-sand/10 bg-deeper px-2 py-[12px]" data-id="element-3324" data-mp="28tjvfpy34lw3">
                  <span className={`shrink-0 rounded-pill border px-[10px] py-[3px] text-[10.5px] font-bold tracking-wide ${badge.label === 'PROTÓTIPO' ? 'border-gold bg-gold text-deep' : badge.label === 'MARCO 3' ? 'border-sand/50 text-sand' : 'border-dashed border-sand/40 text-ondark'}`} data-id="element-3325" data-mp="2iqybvpk0daoe">
                    {badge.label}
                  </span>
                  <span className="text-[13px] leading-snug text-sand" data-id="element-3326" data-mp="2sdr2peumb88w">{badge.text}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </header>

      <main className="mx-auto max-w-[1200px] px-3 md:px-5" data-id="element-3327" data-mp="2igw7p5xjzpzd">
        <section aria-labelledby="mobile" className="pt-6" data-id="element-3328" data-mp="2iih0or47z0v4">
          <SectionHeading id="mobile" title="App Mobile" subtitle="Principais experiências do usuário" data-id="element-3329" data-mp="24qssv0106yjy" />
          <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-3330" data-mp="29ou8tc34uhr7">
            {mobileReviewScreens.map(screen => <li key={screen.id} data-id="element-3331" data-mp="1zq53eisfapru">
                <ReviewScreenCard name={screen.name} description={screen.description} route={screen.route} thumbnail={<MobileThumbnail heading={screen.heading ?? screen.name} blocks={screen.preview} data-id="element-3333" data-mp="2y27o2tu11ysx" />} data-id="element-3332" data-mp="1zqelzlb51uni" />
              </li>)}
          </ul>
        </section>

        <section aria-labelledby="admin" className="pt-6" data-id="element-3334" data-mp="2t8we4jtx51ws">
          <SectionHeading id="admin" title="Admin Web" subtitle="Gestão, operação, análise e governança da plataforma" data-id="element-3335" data-mp="2obd0nm51ot5w" />
          <ul className="grid grid-cols-1 gap-2 md:grid-cols-2 lg:grid-cols-3" data-id="element-3336" data-mp="2faybucsvgvxn">
            {adminReviewScreens.map(screen => <li key={screen.id} data-id="element-3337" data-mp="2ad6dazxq2bkh">
                <ReviewScreenCard name={screen.name} description={screen.description} route={screen.route} thumbnail={<AdminThumbnail title={screen.name} blocks={screen.preview} data-id="element-3339" data-mp="8k8nze35m14a" />} data-id="element-3338" data-mp="2ae7vrph2i0c8" />
              </li>)}
          </ul>
        </section>

        <section aria-labelledby="revisao01" className="pt-6" data-id="element-3340" data-mp="b68055i14juy">
          <SectionHeading id="revisao01" title="Revisão do cliente · Revisão 01" subtitle="Itens para aprovação" data-id="element-3341" data-mp="b3lpuy3r7q91" />
          <div className="flex flex-col gap-2 rounded-panel border border-sand-line bg-white p-3 shadow-card sm:flex-row sm:items-center sm:justify-between" data-id="element-3342" data-mp="kvj7amlcveg7">
            <div className="max-w-[640px]" data-id="element-3343" data-mp="ptkmgwfnutme">
              <h3 className="text-section text-deep" data-id="element-3344" data-mp="3ochtp3c9rexu">Símbolo BEELYV — 3 conceitos de abelha</h3>
              <p className="mt-1 text-[13px] leading-relaxed text-muted" data-id="element-3345" data-mp="3tat1l8j07fdf">
                Alternativas para aprovação. O símbolo atual segue em uso até a escolha.
              </p>
            </div>
            <Button variant="outline" onClick={() => navigate('/marca/conceitos')} data-id="element-3346" data-mp="73l5kwtz4ku2">
              Ver conceitos
            </Button>
          </div>
        </section>

        <section aria-labelledby="entregas" className="pt-6" data-id="element-3347" data-mp="1dm17nfup31px">
          <SectionHeading id="entregas" title="Entregas do Marco 2" subtitle="O que esta etapa consolida" data-id="element-3348" data-mp="1ihyp5php2e4a" />
          <div className="grid gap-x-4 gap-y-3 md:grid-cols-2 lg:grid-cols-4" data-id="element-3349" data-mp="3ekuxgvi38suo">
            {marco2Deliverables.map(item => <div key={item.title} className="border-t-2 border-gold pt-2" data-id="element-3350" data-mp="39p5wcnqf73w9">
                <h3 className="text-section text-deep" data-id="element-3351" data-mp="3nmb18keedwpx">{item.title}</h3>
                <p className="mt-1 text-[13px] leading-relaxed text-muted" data-id="element-3352" data-mp="3jkzeqnqtlrly">{item.description}</p>
              </div>)}
          </div>
        </section>

        <section aria-labelledby="proximo" className="pt-6" data-id="element-3353" data-mp="2qwk6ck2727jl">
          <SectionHeading id="proximo" title="Próxima etapa" subtitle="O que ainda não faz parte desta entrega" data-id="element-3354" data-mp="2qy50w9oidqhg" />
          <div className="grid gap-2 lg:grid-cols-[1.4fr_1fr]" data-id="element-3355" data-mp="34q327ybzai32">
            <div className="rounded-panel bg-deep p-4 text-sand" data-id="element-3356" data-mp="2zw7671f9z5aj">
              <span className="rounded-pill border border-sand/50 px-[10px] py-[3px] text-[10.5px] font-bold tracking-wide" data-id="element-3357" data-mp="2c7fo52veg3bh">
                MARCO 3
              </span>
              <h3 className="mt-2 text-title" data-id="element-3358" data-mp="283zqq4bi9yxq">Marco 3 — Backend + Alpha</h3>
              <p className="mt-2 text-[14px] font-medium text-gold" data-id="element-3359" data-mp="1y0kptqi5xogx">Ainda não implementado nesta entrega:</p>
              <ul className="mt-1 grid gap-x-3 sm:grid-cols-2" data-id="element-3360" data-mp="22u6r6mivm5xf">
                {notInThisDelivery.map(item => <li key={item} className="flex items-center gap-1 border-b border-sand/10 py-1 text-[14px] text-sand" data-id="element-3361" data-mp="1o24vlenu9z37">
                    <span className="h-[6px] w-[6px] shrink-0 rounded-pill border border-gold" aria-hidden="true" data-id="element-3362" data-mp="2gswpu6lcgdnw" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div className="rounded-panel border border-dashed border-deep/30 p-4" data-id="element-3363" data-mp="26v8rl6oj4o0z">
              <span className="rounded-pill border border-dashed border-deep/30 px-[10px] py-[3px] text-[10.5px] font-bold tracking-wide text-muted" data-id="element-3364" data-mp="2bt0wd1a9w4ml">
                FUTURO
              </span>
              <h3 className="mt-2 text-title text-deep" data-id="element-3365" data-mp="10e594qxk8uuf">Integrações futuras</h3>
              <p className="mt-2 text-[14px] leading-relaxed text-muted" data-id="element-3366" data-mp="10c0vhh9v0hgy">
                Apple Health, Google Health Connect, Garmin, Strava e outros serviços externos permanecem
                como integrações futuras e não estão conectados no protótipo atual.
              </p>
            </div>
          </div>
        </section>

        <section aria-labelledby="homologacao" className="py-6" data-id="element-3367" data-mp="3ol968fq7mpp">
          <div className="flex flex-col gap-3 rounded-panel border border-sand-line bg-white p-4 shadow-card md:flex-row md:items-center md:justify-between md:p-5" data-id="element-3368" data-mp="3qfsxjf9h8s7">
            <div className="max-w-[560px]" data-id="element-3369" data-mp="vfspitfo12dp">
              <h2 id="homologacao" className="text-title text-deep" data-id="element-3370" data-mp="qoix5l2qfky4">
                Entrega para homologação
              </h2>
              <p className="mt-1 text-[14px] leading-relaxed text-muted" data-id="element-3371" data-mp="mnqn4pm1dc0s">
                Esta apresentação integra a entrega do Marco 2 — UX/UI e Fundação do projeto BEELYV.
              </p>
            </div>
            <div className="flex flex-col gap-1 sm:flex-row" data-id="element-3372" data-mp="1edbo134hz2lv">
              <Button size="lg" onClick={() => navigate(withClientReview('/index'))} data-id="element-3373" data-mp="2x14udvxqdg05">
                Explorar App Mobile
              </Button>
              <Button size="lg" variant="outline" onClick={() => navigate(withClientReview('/admin'))} data-id="element-3374" data-mp="320hqz8eem1fx">
                Explorar Admin
              </Button>
            </div>
          </div>
        </section>
      </main>

      <footer className="border-t border-sand-line" data-id="element-3375" data-mp="3ayjm57bghzva">
        <div className="mx-auto flex max-w-[1200px] flex-col gap-[4px] px-3 py-3 text-[11.5px] text-muted md:flex-row md:items-center md:justify-between md:px-5" data-id="element-3376" data-mp="3g0iqokixn2tt">
          <span data-id="element-3377" data-mp="3ppisebotkcbp">Desenvolvimento e arquitetura</span>
          <span data-id="element-3378" data-mp="3pqttu4usl7zn">
            M AI — Soluções Inteligentes ·{' '}
            <a href="https://mai.dev.br" target="_blank" rel="noreferrer" className="underline decoration-sand-line underline-offset-2 hover:text-deep" data-id="element-3379" data-mp="3trnix1jz0su4">
              mai.dev.br
            </a>
          </span>
        </div>
      </footer>
    </div>;
}